<template>
<div class="chapter">
<div class="inner_page">
<div id="part-i">
<div class="story">
<p class="x1part-num"><span class="bold"><a href="#/text/9780062030580_Contents#part-i">Part I</a></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062030580_Part_1.vue?74a54084